<template>
  <div class="login-activate.view">
    <login-activate-form
      ref="loginActivateForm"
      @onSubmit="onSubmit"
    />
  </div>
</template>

<script>
import LoginActivateForm from '@/modules/login/login-activate-form'
import http from '@/services/http.service'

/**
   * 'LoginActivate.view' Component
   * @version 1.0.0
   * @author Fernando Torres
   * @copyright Marciano Studio S.C., 2018
   */
export default {
  name: 'LoginActivateView',
  components: {LoginActivateForm},
  data () {
    return {
      hasError: false
    }
  },
  methods: {
    onSubmit (model) {
      console.log(model)
      http.put('users/activate/' + this.$route.query.token, model)
        .then(response => {
          this.$router.push({name: 'login-activate-success'})
        })
        .catch(e => {
          console.log(e)
          this.hasError = true
          this.$emit('onError', this.hasError)
          this.$notify('El token ya fue usado o es invalido')
        })
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .login-activate.view {

  }
</style>



// WEBPACK FOOTER //
// src/views/login/login-activate.view.vue